{
  "nearby": {
    "title": "Что посмотреть",
    "showAll": "Смотреть все"
  }
}
